/**
 * IBSGroupAdminPage (P428.1).
 *
 * Mount point for /foundation/admin/ibs-groups. Thin wrapper handing
 * the adapter to the shared AdminListView, as every other register does.
 *
 * Round 16 O1 -- and the signed group register, offered here where the
 * groups are governed, to the seats that may take it.
 */
import { canRunOperations } from "shared/api/authority";
import { useMe } from "shared/api/useMe";
import { GroupRegisterDownload } from "shared/groups/GroupRegisterDownload";

import { AdminListView } from "./AdminListView";
import { ibsGroupAdapter } from "./ibsGroupAdapter";

export function IBSGroupAdminPage() {
  const me = useMe();
  return (
    <div className="space-y-4">
      {canRunOperations(me.data) && <GroupRegisterDownload />}
      <AdminListView adapter={ibsGroupAdapter} />
    </div>
  );
}
